import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Project } from 'src/app/classes/project.class';
import { User } from 'src/app/classes/user.class';
import { CodaltComponent } from '../../codalt.component';

@Component({
    selector: 'app-project-detail-dialog',
    templateUrl: './project-detail-dialog.component.html',
    styleUrls: ['./project-detail-dialog.component.scss'],
    standalone: false,
})
export class ProjectDetailDialogComponent extends CodaltComponent {
    constructor(
        public dialogRef: MatDialogRef<ProjectDetailDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            project: Project;
            executor?: User;
            projectManager?: User;
        }
    ) {
        super();
    }

    onClose() {
        this.dialogRef.close();
    }
}
